<template>
  <div>
    <a-card>
      <a-form layout="inline" class="mb-40">
        <a-row :gutter="20">
          <a-col :span="8">
            <a-form-item label="师傅信息">
              <a-input placeholder="电话/名称" v-model.trim="time.masterInfo" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="签字时间">
              <a-range-picker
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                format="YYYY-MM-DD"
                @change="onChangeTime"
                style="width: 90%"
                v-model="time.dateString"
              />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-button type="primary" @click="query(1)" style="float:right;">
              查询
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <a-row type="flex" justify="end" class="mb-20">
        <a-button type="primary" html-type="submit" @click="FileExcel">
          导出数据
        </a-button>
        <a-button class="ml-20" type="primary" html-type="submit" @click="outImg">
          导出图片
        </a-button>
      </a-row>
      <a-table :columns="columns" :data-source="data" bordered :pagination="false" size="middle">
        <span slot="id" slot-scope="text, record"> {{ (pageNum - 1) * 10 + data.indexOf(record) + 1 }} </span>
        <span slot="action" slot-scope="text, record">
          <a @click="showImg(record)">查看</a>
          <a-divider type="vertical" />
          <a @click="downLoadImg(record)">下载</a>
        </span>
      </a-table>
      <a-pagination
        showQuickJumper="true"
        showSizeChanger
        :pageSizeOptions="pageSizeOptions"
        :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange"
        :total="total"
        v-model="current"
        @change="getdataList"
        :showTotal="total => `总共 ${total} 条`"
        style="text-align: right; margin-top: 20px"
      />
    </a-card>
    <!-- 签字图片 -->
    <a-modal title="师傅签字" width="800px" :visible="visible" :footer="null" @cancel="visible = false">
      <div class="screen" style="max-height:900px;overflow-y:scroll;">
        <img style="width:100%" :src="item.confirmUrl" alt="" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { getagreementConfirmList } from '@/api/finance/masterDeposit'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  data() {
    return {
      dateString: '', // 时间选择
      time: {
        masterInfo: '', // 师傅信息
        startTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' },
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '电话',
          dataIndex: 'phoneNumber',
          align: 'center'
        },
        {
          title: '身份证',
          dataIndex: 'card',
          align: 'center'
        },
        {
          title: '签字时间',
          dataIndex: 'confirmTime',
          align: 'center'
        },
        {
          title: '图片',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      selectedRowKeys: [],
      data: [],
      current: 1,
      total: 0, // 总条数
      pageNum: 1,
      pageSize: '10',
      pageSizeOptions: ['10', '20', '30', '40'],
      visible: false,
      item: {}
    }
  },

  created() {
    this.getMasterDeposit()
  },
  mounted() {},
  methods: {
    moment,
    // 选择时间
    onChangeTime(date, dateString) {
      this.time.startTime = dateString[0]
      this.time.endTime = dateString[1]
    },
    // 导出数据
    FileExcel() {
      var str =
        process.env.VUE_APP_API_BASE_URL +
        `/order/comSign/exportSignImg?pageNum=${this.pageNum}&pageSize=${this.pageSize}&startTime=${this.time.startTime}&endTime=${this.time.endTime}&searchStr=${this.time.masterInfo}&token=${this.$store.state.user.token}`
      window.open(str)
    },
    // 导出图片
    outImg() {
      var str =
        process.env.VUE_APP_API_BASE_URL +
        `/order/comSign/downloadPic?pageNum=${this.pageNum}&pageSize=${this.pageSize}&startTime=${this.time.startTime}&endTime=${this.time.endTime}&searchStr=${this.time.masterInfo}&token=${this.$store.state.user.token}`
      console.log(str)
      window.open(str)
      this.$message.warn('下载文件较大，请耐心等待...', 6)
    },
    // 多选
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys changed: ', selectedRowKeys, selectedRows)
      this.selectedRowKeys = selectedRowKeys
    },
    // 获取列表
    async getMasterDeposit() {
      try {
        const res = await getagreementConfirmList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          startTime: this.time.startTime,
          endTime: this.time.endTime,
          searchStr: this.time.masterInfo
        })
        this.data = res.rows
        this.total = res.total
      } catch (err) {
        console.log(err)
      }
    },
    // 分页
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.getdataList(current)
    },
    getdataList(value) {
      this.current = value
      this.pageNum = value
      this.getMasterDeposit()
    },
    // 查找
    query(page) {
      if (page == 1) {
        this.pageNum = 1
        this.current = 1
      }
      this.getMasterDeposit()
    },
    // 查看签字图片
    showImg(item) {
      this.visible = true
      this.item = item
    },
    // 下载签字图片
    downLoadImg(item) {
      var url = item.confirmUrl.replace('https://lockan.obs.cn-east-3.myhuaweicloud.com/', '') // 获取图片地址
      window.open(
        process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      )
    }
  }
}
</script>

<style scoped lang="less"></style>
